import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { baseURL } from '@/v2/constants/requests'

export const useGetDoctors = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['Doctors'],
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/doctors`)
      if (!res.ok) {
        throw new Error("We couldn't find the doctors")
      }
      const result = await res.json()
      return result
    },
  })

  const docs = useMemo(() => data || [], [data])
  const firstDoctor = useMemo(() => docs.length > 0 && docs[0], [data])

  const res = useMemo(
    () => ({
      data: data || [],
      loading: isLoading,
      error: isError ? error : null,
    }),
    [isLoading, isError, error, data]
  )

  return { ...res, firstDoctor }
}
